import React from 'react';

import { translate } from '../../../i18n/I18nProvider';

function DeleteUserConfirmation({ name }) {
  return <div>{`${translate('DELETE_TEXT')} : ${name}?`}</div>;
}

export default DeleteUserConfirmation;
